import React from 'react';

import './detail-fields.less';

export const DetailField = ({ label, children, className, style }) => (
  <div className={['detail-field', className].filter(Boolean).join(' ')} style={style}>
    <div className="detail-field__label">{label}</div>
    <div className="detail-field__value">{children ?? '—'}</div>
  </div>
);

/**
 * Label-above-value fields that wrap like flexbox chips: short values share a
 * row, longer content moves to the next line instead of being squeezed.
 */
export const DetailFields = ({ children, className, style }) => (
  <div className={['detail-fields', className].filter(Boolean).join(' ')} style={style}>
    {children}
  </div>
);

export default DetailFields;
